import { useQuery } from '@tanstack/react-query';
import { commonQuotesService } from '@/services/quotes/common';
import type { Product } from '@/services/quotes/types';

export function useProducts() {
  return useQuery({
    queryKey: ['quotes', 'products'],
    queryFn: async (): Promise<Product[]> => {
      const response = await commonQuotesService.getProducts();
      if (!response.success) throw new Error(response.error || 'Erro');
      return response.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
